'use client';

import { DomainContext } from '@/contexts/domain/context';
import { useContext } from 'react';

export const useSiteId = () => useContext(DomainContext)?.siteId;
export const useSiteDomain = () => useContext(DomainContext)?.domain;
